import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<header>
		<p class="p1">100% of proceeds from this shirt will be donated to the<a href="https://www.naacpldf.org/"> NAACP Legal Defense Fund,</a> America’s premier legal organization fighting for racial justice.</p>
		<nav>


<Link activeClassName={style.active} href="/buy">buy</Link> 



</nav><footer clas="make-btn">
 <Link activeClassName={style.active} href="/make">MAKE YOUR OWN T for Donations</Link> 
 </footer>
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js